import packageInfo from "../../package.json";


//export const API_URL = 'http://localhost:3000/';
//export const API_URL = 'https://backend-dev.missionswithmonty.com/';
export const API_URL = 'https://backend.missionswithmonty.com/';

export const BUCKET_URL = "https://s3.us-east-2.amazonaws.com/uploadmontydev/";
//export const BUCKET_URL = "https://s3.us-east-2.amazonaws.com/uploadbeta/";

//export const GAME_URL = 'https://gamedev.missionswithmonty.com/';
export const GAME_URL = 'https://gamedev.missionswithmonty.com/';
//export const GAME_URL = 'https://game.missionswithmonty.com/';

export const VERSION = packageInfo.version;

export const MAIN = {
    API: {
        LOGIN: API_URL + 'sessions/login',
        LOGOUT: API_URL + 'sessions/logout',
        TOKEN: API_URL + 'token',
        LIST_USERS: API_URL + 'users/list',
        LIST_SCHOOLS: API_URL + 'users/list-schools',
        LIST_ADMIN_SCHOOLS: API_URL + 'users/list-admin-schools',
        LIST_SAMPLING_STRATEGIES: API_URL + 'admin/schooladmins/list-sampling-strategies',
        LIST_PARTICIPANT_GROUPS: API_URL + 'teacher/students/list-participant-groups',
        CREATE_SCHOOL: API_URL + 'admin/schools/create',
        UPDATE_SCHOOL: API_URL + 'admin/schools/update',
        CREATE_USERS: API_URL + 'users/create',
        UPDATE_USERS: API_URL + 'users/update',
        DELETE_PARENT: API_URL + 'teacher/students/delete-parent',
        RESET_PASSWORD: API_URL + 'users/password-reset',
        CHANGE_PASSWORD: API_URL + 'users/newpassword',
        RESET_USERNAME: API_URL + 'users/username-request',
        RESET_STUDENT_USERNAME: API_URL + 'users/student-username-request',
        TEACHER_CONSENT: API_URL + 'users/teacher-consent',
        REQUEST_ACCOUNT: API_URL + 'account-request',
        REQUEST_HELP: API_URL + 'help',
        REPORT_BUG: API_URL + 'report-bug',
        GET_CLASS_LIST: API_URL + 'teacher/classes/list',
        GET_TEACHER_CLASS_LIST: API_URL + 'teacher/classes/list-teacher-class',
        ADD_NEW_CLASS: API_URL + 'teacher/classes/create',
        UPDATE_CLASS: API_URL + 'teacher/classes/update',
        DELETE_CLASS: API_URL + 'teacher/classes/delete',
        LIST_EXTERNAL_TEACHER: API_URL + 'teacher/classes/external-list',
        LIST_STUDENTS: API_URL + 'teacher/students/list',
        LIST_PERFORMANCE: API_URL + 'teacher/students/list-performance',
        ADD_NEW_STUDENT: API_URL + 'teacher/students/create',
        UPDATE_STUDENT: API_URL + 'teacher/students/update',
        TRANSFER_STUDENT: API_URL + 'teacher/students/transfer',
        DELETE_STUDENT: API_URL + 'teacher/students/delete',
        STUDENT_NOTIFICATIONS: API_URL + 'teacher/students/notifications',
        LIST_TEACHERS: API_URL + 'admin/teachers/list',
        LIST_TEACHERS_IN_SCHOOL: API_URL + 'admin/teachers/list-teachers-in-school',
        CREATE_TEACHER: API_URL + 'admin/teachers/create',
        UPDATE_TEACHER: API_URL + 'admin/teachers/update',
        DELETE_TEACHER: API_URL + 'admin/teachers/delete',
        LIST_SCHOOLADMINS: API_URL + 'admin/schooladmins/list',
        CREATE_SCHOOLADMIN: API_URL + 'admin/schooladmins/create',
        UPDATE_SCHOOLADMIN: API_URL + 'admin/schooladmins/update',
        DELETE_SCHOOLADMIN: API_URL + 'admin/schooladmins/delete',
        GET_STUDENT_BEST_SCORE: API_URL + 'student/bestscores/view',
        CHECK_STUDENT_DATA: API_URL + 'teacher/students/checkStudentData',

        GET_MAZE_CONTENT: API_URL + 'apps/maze/mazecontent',
        GET_MAZE_SCORE_COUNT: API_URL + 'apps/maze/countscores',
        GET_MAZE_DISTRACTORS: API_URL + 'apps/maze/distractors',
        LIST_RANDOM_MAZE: API_URL + 'apps/maze/mazerandom',
        LIST_MAZE_SCORE_DATA: API_URL + 'apps/maze/score-data',
        UPDATE_MAZE_SCORE: API_URL + 'apps/maze/mazebestscore',
        UPDATE_MAZE_SCORE_NOTE: API_URL + 'apps/maze/score-note',
        POST_MAZE_SESSION: API_URL + 'apps/maze/maze-session',

        GET_SLASH_CONTENT: API_URL + 'apps/slash/slashcontent',
        LIST_RANDOM_SLASH: API_URL + 'apps/slash/slashrandom',
        LIST_SLASH_SCORE_DATA: API_URL + 'apps/slash/score-data',
        UPDATE_SLASH_SCORE: API_URL + 'apps/slash/slashbestscore',
        UPDATE_SLASH_SCORE_NOTE: API_URL + 'apps/slash/score-note',
        POST_SLASH_SESSION: API_URL + 'apps/slash/slash-session',

        ADD_WORDMARK_SESSION: API_URL + 'apps/wordmark/wordmark-session',
        LIST_WORDMARK_SCORE: API_URL + 'apps/wordmark/score-list',
        UPDATE_WORDMARK_GRADE: API_URL + 'apps/wordmark/wordmark-grade',
        LIST_RANDOM_WORDMARK: API_URL + 'apps/wordmark/wordmarkrandom',
        GET_WORDMARK_SCORE_DATA: API_URL + 'apps/wordmark/score-data',
        UPDATE_WORDMARK_SCORE_NOTE: API_URL + 'apps/wordmark/score-note',
        POST_WORDMARK_SESSION: API_URL + 'apps/wordmark/wordmark-session',
        DELETE_WORDMARK_SCORE: API_URL + 'apps/wordmark/delete',
        GET_WORDMARK_SESSION: API_URL + 'apps/wordmark/wordmark-session',

        UPLOAD_KIDSPEAK_FILE: API_URL + 'apps/kidspeak/upload',
        DELETE_KIDSPEAK_FILE: API_URL + 'apps/kidspeak/delete-audio',
        ADD_KIDSPEAK_SESSION: API_URL + 'apps/kidspeak/ks-session',
        GET_KIDSPEAK_SESSION: API_URL + 'apps/kidspeak/ks-session',
        GET_KIDSPEAK_SCORE_LIST: API_URL + 'apps/kidspeak/score-list',
        UPDATE_KIDSPEAK_GRADE: API_URL + 'apps/kidspeak/ks-grade',
        GET_KIDSPEAK_RANDOM: API_URL + 'apps/kidspeak/ksrandom',
        GET_KIDSPEAK_DATA: API_URL + 'apps/kidspeak/score-data',
        UPDATE_KIDSPEAK_SCORE_NOTE: API_URL + 'apps/kidspeak/score-note',
        DELETE_KIDSPEAK_SCORE: API_URL + 'apps/kidspeak/delete',
        UPDATE_KIDSPEAK_BEST_SCORE:API_URL + "apps/kidspeak/ksbestscore",
        List_KIDSPEAK_PASSAGE: API_URL + "apps/kidspeak/list-passage",
        List_KIDSPEAK_PASSAGE_BY_UID: API_URL + "apps/kidspeak/list-passage-by-uid",
        ADD_KIDSPEAK_PASSAGE: API_URL + "apps/kidspeak/add-passage",
        DELETE_KIDSPEAK_PASSAGE: API_URL + "apps/kidspeak/delete-passage",
        UPDATE_KIDSPEAK_PASSAGE: API_URL + "apps/kidspeak/update-passage",
        ACTIVEATE_KIDSPEAK_PASSAGE: API_URL + "apps/kidspeak/activate-passage",

        UPLOAD_PICTURENAMING_FILE: API_URL + 'apps/picturenaming/upload',
        DELETE_PICTURENAMING_FILE: API_URL + 'apps/picturenaming/delete-video',
        ADD_PICTURENAMING_SESSION: API_URL + 'apps/picturenaming/pn-session',
        GET_PICTURENAMING_SESSION: API_URL + 'apps/picturenaming/pn-session',
        GET_PICTURENAMING_SCORE_LIST: API_URL + 'apps/picturenaming/score-list',
        UPDATE_PICTURENAMING_GRADE: API_URL + 'apps/picturenaming/pn-grade',
        PICTURENAMING_MANUAL_GRADE: API_URL + 'apps/picturenaming/pn-manual-grade',
        GET_PICTURENAMING_MANUAL_SCORE: API_URL + 'apps/picturenaming/pn-manual-score',
        GET_PICTURENAMING_RANDOM: API_URL + 'apps/picturenaming/pnrandom',
        GET_PICTURENAMING_DATA: API_URL + 'apps/picturenaming/score-data',
        UPDATE_PICTURENAMING_SCORE_NOTE: API_URL + 'apps/picturenaming/score-note',
        ADD_PICTURENAMING_1ON1: API_URL + 'apps/picturenaming/pn-1On1',
        DELETE_PICTURENAMING_SCORE: API_URL + 'apps/picturenaming/delete',
        START_PICTURENAMING_WEBSOCKET: API_URL.replace("http","ws") + 'apps/picturenaming/session-join',
        UPDATE_PICTURENAMING_BEST_SCORE:API_URL + "apps/picturenaming/pnbestscore",

        UPLOAD_COPYRIGHT_FILE: API_URL + 'apps/copyright/upload',
        DELETE_COPYRIGHT_FILE: API_URL + 'apps/copyright/delete-audio',
        ADD_COPYRIGHT_SESSION: API_URL + 'apps/copyright/cr-session',
        GET_COPYRIGHT_SESSION: API_URL + 'apps/copyright/cr-session',
        GET_COPYRIGHT_SCORE_LIST: API_URL + 'apps/copyright/score-list',
        UPDATE_COPYRIGHT_GRADE: API_URL + 'apps/copyright/cr-grade',
        GET_COPYRIGHT_RANDOM: API_URL + 'apps/copyright/crrandom',
        GET_COPYRIGHT_DATA: API_URL + 'apps/copyright/score-data',
        UPDATE_COPYRIGHT_SCORE_NOTE: API_URL + 'apps/copyright/score-note',
        DELETE_COPYRIGHT_SCORE: API_URL + 'apps/copyright/delete',
        UPDATE_COPYRIGHT_BEST_SCORE:API_URL + "apps/copyright/crbestscore",


        UPLOAD_WORDSIGNSAY_FILE: API_URL + 'apps/wordsignsay/upload',
        DELETE_WORDSIGNSAY_FILE: API_URL + 'apps/wordsignsay/delete-video',
        ADD_WORDSIGNSAY_SESSION: API_URL + 'apps/wordsignsay/wss-session',
        GET_WORDSIGNSAY_SESSION: API_URL + 'apps/wordsignsay/wss-session',
        GET_WORDSIGNSAY_SCORE_LIST: API_URL + 'apps/wordsignsay/score-list',
        UPDATE_WORDSIGNSAY_GRADE: API_URL + 'apps/wordsignsay/wss-grade',
        GET_WORDSIGNSAY_RANDOM: API_URL + 'apps/wordsignsay/wssrandom',
        GET_WORDSIGNSAY_DATA: API_URL + 'apps/wordsignsay/score-data',
        UPDATE_WORDSIGNSAY_SCORE_NOTE: API_URL + 'apps/wordsignsay/score-note',
        UPDATE_WORDSIGNSAY_BEST_SCORE:API_URL + "apps/wordsignsay/wssbestscore",
        DELETE_WORDSIGNSAY_SCORE: API_URL + 'apps/wordsignsay/delete',

        UPLOAD_KIDSIGN_FILE: API_URL + 'apps/kidsign/upload',
        DELETE_KIDSIGN_FILE: API_URL + 'apps/kidsign/delete-audio',
        ADD_KIDSIGN_SESSION: API_URL + 'apps/kidsign/kss-session',
        GET_KIDSIGN_SESSION: API_URL + 'apps/kidsign/kss-session',
        GET_KIDSIGN_SCORE_LIST: API_URL + 'apps/kidsign/score-list',
        UPDATE_KIDSIGN_GRADE: API_URL + 'apps/kidsign/kss-grade',
        GET_KIDSIGN_RANDOM: API_URL + 'apps/kidsign/kssrandom',
        GET_KIDSIGN_DATA: API_URL + 'apps/kidsign/score-data',
        UPDATE_KIDSIGN_SCORE_NOTE: API_URL + 'apps/kidsign/score-note',
        DELETE_KIDSIGN_SCORE: API_URL + 'apps/kidsign/delete',
        UPDATE_KIDSIGN_BEST_SCORE:API_URL + "apps/kidsign/kssbestscore",

        GET_USER_BESTSCORES: API_URL + "student/bestscores/grade-view",
        GET_STUDENT_APPS_STATUS: API_URL + "student/apps/status",
        GET_PARENT_STUDENTS: API_URL + "student/apps/getParentStudents",

        ADD_ANALYTICS: API_URL + "analytics/add",
        ADD_ANALYTICS_NONUSER: API_URL + "analytics/add-nonuser"


    }
};
